<template>
    <div :class="['m-listingitem grid-item', resultItem.Featured ? 'featured' : '']">
        <div class="e-text flow-m">
            <div class="flow">
                <p :class="['result-tag', resultItem.DocType.toLowerCase().trim()]">{{resultItem.DocumentTypeName.toUpperCase()}}</p>
                <h2><a :href="resultItem.Link.Url">{{resultItem.Heading}}</a></h2>
            </div>

            <div class="flow">
                <p v-if="resultItem.DocType != 'event'">
                    <template v-if="resultItem.Date != null && resultItem.Subheading == ''">
                        <span>{{formatDate(resultItem.Date.DateTime)}}</span>
                    </template>
                    {{resultItem.Subheading}}
                    <template v-if="resultItem.Content.ArticleDetails != null && resultItem.Content.ArticleDetails.PodcastCount > 0">
                        <span class="read-time">{{resultItem.Content.ArticleDetails.PodcastCount}} <template v-if="resultItem.Content.ArticleDetails.PodcastCount == 1">episode</template><template v-if="resultItem.Content.ArticleDetails.PodcastCount > 1">episodes</template></span>
                    </template>
                </p>
                <ul class="inline-list" v-if="resultItem.DocType == 'event'">
                    <li v-if="datesAreOnSameDay(resultItem.Content.EventStartDatetime, resultItem.Content.EventStartDatetime)">{{formatDate(resultItem.Content.EventStartDatetime, dateFormatUi())}}</li>
                    <li v-if="!datesAreOnSameDay(resultItem.Content.EventStartDatetime, resultItem.Content.EventStartDatetime)">{{formatDate(resultItem.Content.EventEndDatetime, dateFormatUi())}}</li>
                    <li>{{formatDate(resultItem.Content.EventStartDatetime, dateFormatTime())}} - {{formatDate(resultItem.Content.EventEndDatetime, dateFormatTime())}}</li>
                </ul>
                <profile-actions class="m-listingitem__actions--inverse" :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
            <ul class="blog-tags" v-if="filteredTags.length > 0">
                <li v-for="tag in filteredTags" :key="tag.name">
                    <a :href="tag.link">{{tag.name}}</a>
                </li>
            </ul>
            <!-- <div v-if="resultItem.Summary != null" class="taster">
                <p>{{resultItem.Summary}}</p>
            </div> -->
            <div class="m-listingitem__action">
                <a :href="resultItem.Link.Url" class="btn btn--outline">Find out more</a>
            </div>
        </div>
    </div>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { format, toDate } from '@/utils/date.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions
        },
        computed: {
            tagsShownOnResults() {
                return this.$store.state.search.tagsShownOnResults || []
            },
            filteredTags() {
                const tagsShownOnResults = this.$store.state.search.tagsShownOnResults || []

                if (tagsShownOnResults.length === 0 || !this.resultItem.Tagged) {
                    return []
                }
            
                const allowedChildTags = new Set(
                    tagsShownOnResults.flatMap(group => group.Children || [])
                )
         
                return this.resultItem.Tagged
                    .map((tag, index) => ({
                        name: tag,
                        link: this.resultItem.TaggedFilterParamters[index]
                    }))
                    .filter(tagObject => allowedChildTags.has(tagObject.name))
            }
        },
        methods: {
            
            dateFormatUi() {
                return Globals.dateFormatUi
            },

            dateFormatTime() {
                return Globals.dateFormatTime
            },

            datesAreOnSameDay(first, second) {
                var d1 = toDate(first)
                var d2 = toDate(second)

                return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
            },

            getDate(date) {
                return toDate(date)
            },

            formatDate(date, formatter) {
                return format(toDate(date), formatter || Globals.dateFormatMonthYear)
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            }
        }
    }
</script>
